import type { CompanySheet } from '@/types/category';
import { CompanyCard } from '@/components/CompanyCard';

interface CompanyGridProps {
  companies: CompanySheet[];
  onCompanyClick: (id: number) => void;
  sectorMap?: Map<number, string>;
}

export function CompanyGrid({
  companies,
  onCompanyClick,
  sectorMap,
}: CompanyGridProps) {
  if (companies.length === 0) {
    return (
      <div className="flex items-center justify-center h-64 text-grey-hover text-lg">
        No models found
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-6">
      {companies.map((company) => (
        <CompanyCard
          key={company.id}
          company={company}
          onClick={() => onCompanyClick(company.id)}
          sectorName={sectorMap?.get(company.id)}
        />
      ))}
    </div>
  );
}
